import { Button } from '@resiliatech/birdsong'
import { useHistory } from 'react-router'
import {
  ContentContainer,
  GoalPageEmptyStateContainer,
  Header,
} from './EmptyStates.styled'
import { IMPACT_GOALS_PATH } from '../utils'

export const GoalPageEmptyState = () => {
  const history = useHistory()

  const handleClickBackToGoals = () => {
    history.push(IMPACT_GOALS_PATH)
  }

  return (
    <GoalPageEmptyStateContainer>
      <Header>We couldn&apos;t find the goal you&apos;re looking for</Header>
      <ContentContainer>
        Here&apos;s some things that you can try
        <ul>
          <li>Make sure you entered the correct details for your goal.</li>
          <li>
            Hit the refresh button or try searching for your goal one more time.
          </li>
          <li>
            If your goal isn&apos;t listed, you can create a new one from
            scratch.
          </li>
        </ul>
      </ContentContainer>
      <Button
        label='Back to Goals'
        variant='primary'
        onClick={handleClickBackToGoals}
      />
    </GoalPageEmptyStateContainer>
  )
}
